// extracted by mini-css-extract-plugin
module.exports = {"header":"dd31006766--header--n37G1","block":"dd31006766--block--Vshae","row":"dd31006766--row--plNOd","mobile":"dd31006766--mobile--Mbrbl","cell":"dd31006766--cell--Jn8mY"};